// import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({

    state: {

        idMaterial: "",
        page_agreement(url) {
            window.open(url, '_blank');
        },
    },
    mutations: {
        addId(state,data){
            state.idMaterial = data;
        }
    },
    actions: {},
    getters: {}

});